import { createAction } from "redux-actions";
import { moduleSlug } from "modules/Metric/services/constants";

export const clearMetricDataCollectionStatus = createAction(`${moduleSlug}/CLEAR_METRIC_DATA_COLLECTION_STATUS`);

export const exportMetricDataCollectionStatus = createAction(`${moduleSlug}/EXPORT_METRIC_DATA_COLLECTION_STATUS`);

export const getMetricDataCollectionStatus = createAction(`${moduleSlug}/GET_METRIC_DATA_COLLECTION_STATUS`);
export const getMetricDataCollectionStatusSuccess = createAction(`${moduleSlug}/GET_METRIC_DATA_COLLECTION_STATUS/SUCCESS`);
export const getMetricDataCollectionStatusError = createAction(`${moduleSlug}/GET_METRIC_DATA_COLLECTION_STATUS/ERROR`);

export const updateMetricDataCollectionStatus = createAction(`${moduleSlug}/UPDATE_METRIC_DATA_COLLECTION_STATUS`);
